import React from "react";

export const userContext = React.createContext({
  language: null,
  languageFranchise: null,
  translation: null,
  userCognito: null,
  franchise: null,
  menuOpen: false
});

export default userContext;
